
import util from 'server/js/util';

module.exports = {
	'api/agents/checkAgent': { method: 'GET' },
	'api/bso/data': { method: 'GET' },
	'api/bso/findBsoOrders': { method: 'POST' },
	'api/bso/sendEmail': { method: 'POST' },
	'api/calculatorFeedback/data': { method: 'GET' },
	'api/claim/checkStatus': { method: 'POST' },
	'api/complaint/getCategories': { method: 'GET' },
	'api/complaint/submit': {
		method: 'POST',
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
	},
	'api/completeOrder': { method: 'GET' },
	'api/completenessDoc/saveBid': { method: 'POST' },
	'api/dictionary/getStoas': { method: 'GET' },
	'api/dictionary/ModelsForClaim': { method: 'GET' },
	'api/dictionary/citiesKladr': { method: 'GET' },
	'api/dictionary/citiesKladrRsa': { method: 'GET' },
	'api/dictionary/currencyRates': { method: 'GET' },
	'api/dictionary/extendedModels': { method: 'GET' },
	'api/dictionary/CitiesKladrByRegions': { method: 'GET' },
	'api/dictionary/getCurrentTime': { method: 'GET' },
	'api/dictionary/getKladrRsaSettlementName': { method: 'GET' },
	'api/dictionary/getKladrSettlementName': { method: 'GET' },
	'api/dictionary/kasko3ModelModifications': { method: 'GET' },
	'api/dictionary/kaskoBanks': { method: 'GET' },
	'api/dictionary/makers': { method: 'GET' },
	'api/dictionary/modelModificationPrices': { method: 'GET' },
	'api/dictionary/models': { method: 'GET' },
	'api/dictionary/detailedModels': { method: 'GET' },
	'api/dictionary/opf': { method: 'GET' },
	'api/dictionary/opfs': { method: 'GET' },
	'api/dictionary/regionsTimeShift': { method: 'GET' },
	'api/dictionary/streetsKladr': { method: 'GET' },
	'api/dictionary/vehicleType': { method: 'GET' },
	'api/dictionary/vehicleUsageType': { method: 'GET' },
	'api/dictionary/antiTheftSystems': { method: 'GET' },
	'api/greenCard/calculateCase': { method: 'POST' },
	'api/greenCard/getCaseWithKey': { method: 'GET' },
	'api/insuranceApplication': { method: 'POST' },
	'api/kasko3/calculateCase': { method: 'POST' },
	'api/kasko3/data': { method: 'GET' },
	'api/kasko3/getCase': { method: 'GET' },
	'api/kasko3/getPreviousPolicy': { method: 'GET' },
	'api/kasko3/SendProlongationClaim': { method: 'POST' },
	'api/keyCode/checkCode': { method: 'POST' },
	'api/keyCode/createCode': { method: 'POST' },
	'api/mite/calculateCase': { method: 'POST' },
	'api/mite/createOrder': { method: 'POST' },
	'api/mite/data': { method: 'GET' },
	'api/mite/getCase': { method: 'GET' },
	'api/mite/getCaseWithKey': { method: 'GET' },
	'api/offices/getAllCities': { method: 'GET' },
	'api/offices/getAllRegions': { method: 'GET' },
	'api/offices/getCitiesForClaimSettlement': { method: 'GET' },
	'api/offices/getOffice': { method: 'GET' },
	'api/offices/getOffices': {
		method: 'GET',
		_afterAjax: function (promise) {
			return promise.then(util.filter.successTrue);
		},
	},
	'api/offices/getOfficesByBounds': { method: 'GET' },
	'api/offices/getOfficesForClaimSettlement': { method: 'GET' },
	'api/offices/getRegionsForClaimSettlement': { method: 'GET' },
	'api/offices/getOfficesByCityNameAndRegionID': { method: 'GET' },
	'api/osago/data': { method: 'GET' },
	'api/osago/getCase': { method: 'GET' },
	'api/osago/recordPressButton': { method: 'POST' },
	'api/productActivation/activateDmsCard': { method: 'POST' },
	'api/productActivation/checkDmsCardInfo': { method: 'POST' },
	'api/promo/jobOfferForFriend': { method: 'POST' },
	'api/propertyBox/activateBox': { method: 'POST' },
	'api/propertyBox/getBoxPremiums': { method: 'GET' },
	'api/registerClaim/data': { method: 'GET' },
	'api/registerClaim/getPolicyData': { method: 'GET' },
	'api/registerClaim/registerClaim': { method: 'POST' },
	'api/sms/checkQuotation': { method: 'POST' },
	'api/sms/sendQuotation': { method: 'POST' },
	'api/travel3/calculateCase': { method: 'POST' },
	'api/travel3/createOrder': { method: 'POST' },
	'api/travel3/data': { method: 'GET' },
	'api/travel3/getCase': { method: 'GET' },
	'api/travel3/getCaseWithKey': { method: 'GET' },
	'api/travel3ForUSA/calculateCase': { method: 'POST' },
	'api/travel3ForUSA/createOrder': { method: 'POST' },
	'api/travel3ForUSA/data': { method: 'GET' },
	'api/travel3ForUSA/getCaseWithKey': { method: 'GET' },
	'api/vessel/search': {
		type: 'GET',
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
	},
	'api/yacht/calculateCase': { method: 'POST', bodyType: 'form' },
	'api/yacht/data': { method: 'GET' },
	'cmsapi/captcha/check': { method: 'GET' },
	'cmsapi/captcha/generateKey': { method: 'GET' },
	'cmsapi/form/submit': {
		method: 'POST',
		bodyType: 'form',
		headers: {
			'X-Requested-With': 'XMLHttpRequest', // bitrix checks for this
		},
		_afterAjax: function (promise) {
			return promise.then(util.over.json(function (json, response) {
				if (json.success !== true || json.errors) {
					const e = new Error(json.errors || 'success: false');
					e.response = response;
					throw e;
				}
				return response;
			}));
		} },
	'cmsapi/location/getGeoIPInfo': { method: 'GET' },
	'xml/location/getLocation': {
		method: 'GET',
		deprecate: '`any.xml.*` calls are deprecated use `any.cmsapi.*` instead',
	},
};

